import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { registerUser, loginUser, getGoogleLoginUrlApi } from "../services/loginApi";
import { logoutApi } from "../services/api";

export const register = createAsyncThunk("auth/register", async (userData, { rejectWithValue }) => {
  try {
    return await registerUser(userData);
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const login = createAsyncThunk("auth/login", async (credentials, { rejectWithValue }) => {
  try {
    return await loginUser(credentials);
  } catch (error) {
    return rejectWithValue(error);
  }
});

// Get Google login URL
export const getGoogleLoginUrl = createAsyncThunk(
  "auth/getGoogleLoginUrl",
  async (_, { rejectWithValue }) => {
    try {
      return await getGoogleLoginUrlApi();
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get Google login URL");
    }
  }
);



// AsyncThunk for logout
export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await logoutApi();
      return response.data; // { message: "Logged out" }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Logout failed" }
      );
    }
  }
);


const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    // token: localStorage.getItem("access_token")||null,
    loading: false,
    error: null,
    googleLoginUrl: null,
  },
  reducers: {
    setUser: (state, action) => {

      state.user = {
        username: action.payload.username,
        subscription: action.payload.subscription[0],
        email: action.payload.email
      }

    },
    clearUser: (state) => {
      state.user = null;
      state.googleLoginUrl = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(register.fulfilled, (state, action) => { state.loading = false; state.user = action.payload; })
      .addCase(register.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(login.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        
      })
      .addCase(login.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      // Logout
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.loading = false;
        state.user = null; // clear user after logout
        state.googleLoginUrl = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Logout failed";
      })
      // Google Login URL
      .addCase(getGoogleLoginUrl.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(getGoogleLoginUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.googleLoginUrl = action.payload.google_login_url;
      })
      .addCase(getGoogleLoginUrl.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
  },
});

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;


